import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.BlogFilters;

// initial state
// object name must match specification name
const filters = {
	Topic: new FormControl.FilterGroup('Topic', 'Topic', 'All Topics', '', true, false, 'select'),
	searchTerm: new FormControl.FilterGroup(
		'SearchTerm', 'Search by Keyword', null, null, false, true, 'textbox',
		new FormControl.Textbox('Search')
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };